if (!customElements.get('custom-full-360-view')) {
  class Custom360View extends HTMLElement {

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.handle = this.dataset.handle;

      this.activeVariantId = null;
      this.msgTimeout = null;

      this.bindEvents();
      this.applyInitialActiveState();
      this.movePriceWrapperForMobile();

      const wrapper = this.querySelector(".bike-price-wrapper");

      if (wrapper && this.activeVariantId) {
          initLocationPricing(wrapper, this.activeVariantId);
      }

      this.bindCartButton();
      this.bindDownloadButton();
    }

    showLoader() {
      this.classList.add('loading');
    }

    hideLoader() {
      this.classList.remove('loading');
    }

    bindEvents() {
      this.querySelectorAll('.c360-swatch-item').forEach(el => {
        el.addEventListener('click', (e) => {
          const parent = e.currentTarget;

          const id = parent.dataset.variantId;
          const color = parent.dataset.variantColor;

          if (!id) return;

          this.activeVariantId = id;

          this.updateActiveState(parent);
          this.updateVariant(id, color);
        });
      });
    }

    updateActiveState(activeEl) {
      this.querySelectorAll('.c360-swatch-item').forEach(el => {
        el.classList.remove('active');
      });

      activeEl.classList.add('active');

      const color = activeEl.dataset.variantColor;
      const pill = activeEl.querySelector('.c360-pill');

      if (pill && color) pill.style.background = color;

      const title = this.querySelector('.c360-title');
      if (title && color) {
        title.style.setProperty('--variant-color', color);
      }
    }

    applyInitialActiveState() {
      let active = this.querySelector('.c360-swatch-item.active') ||
                   this.querySelector('.c360-swatch-item');

      if (active) {
        const color = active.dataset.variantColor;
        const pill = active.querySelector('.c360-pill');

        this.activeVariantId = active.dataset.variantId;
        active.classList.add('active');

        if (pill && color) pill.style.background = color;

        const title = this.querySelector('.c360-title');
        if (title && color) {
          title.style.setProperty('--variant-color', color);
        }
      }
    }

    // UPDATED CART BUTTON (WITH RESET)
    bindCartButton() {
      const btn = this.querySelector('.c360-add');
      const msg = this.querySelector('.c360-msg');

      if (!btn) return;

      const modal = document.getElementById('prebook-popup-modal');
      const variantInput = modal?.querySelector('.prebook-variant-id');

      btn.addEventListener('click', async () => {
        if (!this.activeVariantId) return;

        try {
          const cart = await fetch('/cart.js').then(r => r.json());

          const exists = cart.items.find(
            item => item.variant_id == this.activeVariantId
          );

          if (exists) {
            this.showMessage(msg);
            return;
          }

          if (modal && variantInput) {
            variantInput.value = this.activeVariantId;

            // RESET MODAL
            modal.querySelectorAll('select').forEach(select => {
              select.selectedIndex = 0;
            });

            modal.querySelector('[name="properties[City]"]').disabled = true;
            modal.querySelector('[name="properties[Dealer]"]').disabled = true;
            modal.querySelector('.go-to-checkout').disabled = true;

            modal.classList.add('open');
            document.body.classList.add('no-scroll');
          }

        } catch (err) {
          console.error('Cart check error:', err);
        }
      });
    }

    bindDownloadButton() {
      const btn = this.querySelector('.c360-btn3');
      if (!btn) return;

      btn.addEventListener('click', (e) => {
        e.preventDefault();

        const url = btn.getAttribute('href');
        if (!url) return;

        const fileName = url.split('/').pop().split('?')[0];

        const a = document.createElement('a');
        a.href = url;
        a.setAttribute('download', fileName || 'download');
        a.setAttribute('rel', 'noopener');

        document.body.appendChild(a);
        a.click();
        a.remove();
      });
    }

    showMessage(el) {
      if (!el) return;

      el.classList.add('active');
      clearTimeout(this.msgTimeout);

      this.msgTimeout = setTimeout(() => {
        el.classList.remove('active');
      }, 2500);
    }

    updateVariant(id, color) {
      const url = `/products/${this.handle}?variant=${id}&section_id=${this.sectionId}`;

      const container = this;
      container.style.height = container.offsetHeight + 'px';

      this.showLoader();

      fetch(url)
        .then(res => res.text())
        .then(htmlText => {
          const html = new DOMParser().parseFromString(htmlText, 'text/html');
          const updated = html.querySelector('custom-full-360-view');

          if (updated) {
            setTimeout(() => {
              this.innerHTML = updated.innerHTML;

              this.bindEvents();
              this.bindCartButton();
              this.bindDownloadButton();
              this.movePriceWrapperForMobile();

              const wrapper = this.querySelector(".bike-price-wrapper");

              if (wrapper) {
                  initLocationPricing(wrapper, id);
              }

              if (window.CI360) {
                try { window.CI360.destroy && window.CI360.destroy(); } catch {}
                window.CI360.init();
              }

              this.applyInitialActiveState();

              // RE-INIT MODAL AFTER RELOAD
              initPrebookModal();

              this.hideLoader();

              setTimeout(() => {
                this.style.height = 'auto';
              }, 400);

            }, 200);
          }

          history.replaceState(null, '', `?variant=${id}`);
        })
        .catch(err => {
          console.error('Variant load error:', err);
          this.hideLoader();
        });
    }

    movePriceWrapperForMobile() {
      if (window.innerWidth > 767) return;

      const priceWrapper = this.querySelector(".bike-price-wrapper");
      const mobilePriceText = this.querySelector(".c360-price-text-mobile");

      if (!priceWrapper || !mobilePriceText) return;

      mobilePriceText.after(priceWrapper);
    }
  }

  customElements.define('custom-full-360-view', Custom360View);
}

// MODAL INIT (SAFE + REUSABLE)
function initPrebookModal() {
  const modal = document.getElementById('prebook-popup-modal');
  if (!modal || modal.dataset.initialized) return;

  modal.dataset.initialized = "true";

  if (!window.DealersLoader) {
    console.error("DealersLoader not found");
    return;
  }

  const overlay = modal.querySelector('.popup-overlay');
  const closeBtn = modal.querySelector('.popup-close-icon');

  const stateSelect = modal.querySelector('[name="properties[State]"]');
  const citySelect = modal.querySelector('[name="properties[City]"]');
  const dealerSelect = modal.querySelector('[name="properties[Dealer]"]');
  const submitBtn = modal.querySelector('.go-to-checkout');
  const form = modal.querySelector('form');

  let dealersData = [];

  function closeModal() {
    modal.classList.remove('open');
    document.body.classList.remove('no-scroll');
  }

  overlay.addEventListener('click', closeModal);
  closeBtn.addEventListener('click', closeModal);

  (async () => {
    try {
      dealersData = await window.DealersLoader.load();

      if (!Array.isArray(dealersData)) {
        dealersData = dealersData.data || [];
      }

      const states = [...new Set(dealersData.map(d => d.state))];

      states.forEach(state => {
        const opt = document.createElement('option');
        opt.value = state;
        opt.textContent = state;
        stateSelect.appendChild(opt);
      });

    } catch (err) {
      console.error('Dealer load failed', err);
    }
  })();

  stateSelect.addEventListener('change', () => {
    citySelect.innerHTML = '<option value="">Select City</option>';
    dealerSelect.innerHTML = '<option value="">Select Dealer</option>';

    citySelect.disabled = true;
    dealerSelect.disabled = true;

    if (!stateSelect.value) return;

    const cities = [...new Set(
      dealersData
        .filter(d => d.state === stateSelect.value)
        .map(d => d.city)
    )];

    cities.forEach(city => {
      const opt = document.createElement('option');
      opt.value = city;
      opt.textContent = city;
      citySelect.appendChild(opt);
    });

    citySelect.disabled = false;
  });

  citySelect.addEventListener('change', () => {
    dealerSelect.innerHTML = '<option value="">Select Dealer</option>';
    dealerSelect.disabled = true;

    if (!citySelect.value) return;

    const dealers = dealersData.filter(
      d => d.state === stateSelect.value && d.city === citySelect.value
    );

    dealers.forEach(d => {
      const opt = document.createElement('option');
      opt.value = d.dealer;
      opt.textContent = d.dealer;
      dealerSelect.appendChild(opt);
    });

    dealerSelect.disabled = false;
  });

  function validate() {
    submitBtn.disabled = !(
      stateSelect.value &&
      citySelect.value &&
      dealerSelect.value
    );
  }

  stateSelect.addEventListener('change', validate);
  citySelect.addEventListener('change', validate);
  dealerSelect.addEventListener('change', validate);

  let isSubmitting = false;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    if (submitBtn.disabled || isSubmitting) return;

    isSubmitting = true;

    submitBtn.classList.add('loading');
    submitBtn.disabled = true;
    submitBtn.style.pointerEvents = 'none';

    const variantId = modal.querySelector('.prebook-variant-id').value;

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: {
            State: stateSelect.value,
            City: citySelect.value,
            Dealer: dealerSelect.value
          }
        })
      });

      window.location.href = '/cart';

    } catch (err) {
      console.error('Add to cart error:', err);

      isSubmitting = false;
      submitBtn.classList.remove('loading');
      submitBtn.disabled = false;
      submitBtn.style.pointerEvents = 'auto';
    }
  });
}

// INITIAL LOAD
document.addEventListener('DOMContentLoaded', initPrebookModal);

// States for dynamic pricing
// MAIN INIT
async function initLocationPricing(wrapper, currentVariantId) {
  if (!wrapper) return;

  const priceEl = wrapper.querySelector(".dynamic-price");

  const mobilePriceWrapper = document.querySelector(".c360-price-text-mobile");

  if (mobilePriceWrapper) {
    mobilePriceWrapper.classList.add("loading");
  }

  const mobilePriceEl = mobilePriceWrapper?.querySelector(".dynamic-price-mobile");

  const locationEl = wrapper.querySelector(".dynamic-location");

  const priceText = wrapper.querySelector(".price-text");

  // DEFAULT FALLBACK
  const defaultPrice = wrapper.dataset.defaultPrice || "₹1.94 Lakh";

  const stateDropdown = wrapper.querySelector(".state-selector");

  // INITIAL LOADING UI
  wrapper.classList.add("loading");

  if (priceText) {
    priceText.classList.add("loading");
  }

  if (priceEl) {
    priceEl.textContent = "Loading...";
  }

  if (mobilePriceEl) {
    mobilePriceEl.textContent = "Loading...";
  }

  if (locationEl) {
    locationEl.textContent = "Ex-Showroom Price*";
  }

  // CITY ALIASES
  const cityAliases = {
    Bengaluru: "Bangalore",
    "Bangalore Urban": "Bangalore",
    Bombay: "Mumbai",
    Madras: "Chennai",
    Trivandrum: "Thiruvananthapuram",
  };

  // MEMORY CACHE
  let cachedLocation = null;

  // LOCAL STORAGE CACHE
  const STORAGE_KEY = "jawa_user_location";
  let activeState = null;

  // GET USER LOCATION
  async function getUserLocation() {
    // MEMORY CACHE
    if (cachedLocation) {
      return cachedLocation;
    }

    // LOCAL STORAGE CACHE
    const storedLocation = localStorage.getItem(STORAGE_KEY);

    if (storedLocation) {
      try {
        cachedLocation = JSON.parse(storedLocation);

        return cachedLocation;
      } catch (e) {}
    }

    // GEOLOCATION
    return new Promise((resolve) => {
      if (!navigator.geolocation) {
        resolve(null);

        return;
      }

      navigator.geolocation.getCurrentPosition(
        async (position) => {
          try {
            const lat = position.coords.latitude;

            const lon = position.coords.longitude;

            const apiUrl = `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${lat}&longitude=${lon}&localityLanguage=en`;

            const response = await fetch(apiUrl);

            const data = await response.json();

            let city =
              data.city ||
              data.locality ||
              data.localityInfo?.administrative?.[2]?.name ||
              "";

            let state = data.principalSubdivision || "";

            city = cityAliases[city] || city;

            cachedLocation = {
              city,
              state,
            };

            // SAVE CACHE
            localStorage.setItem(STORAGE_KEY, JSON.stringify(cachedLocation));

            resolve(cachedLocation);
          } catch (error) {
            resolve(null);
          }
        },

        () => {
          resolve(null);
        },

        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        },
      );
    });
  }

  // REMOVE LOADING
  function removeLoadingState() {
    wrapper.classList.remove("loading");

    if (priceText) {
      priceText.classList.remove("loading");
    }

    if (mobilePriceWrapper) {
      mobilePriceWrapper.classList.remove("loading");
    }
  }

  function populateStatesDropdown(variantData, selectedState = "Delhi") {

    if (!stateDropdown) return;

    stateDropdown.innerHTML = "";

    const states = Object.keys(variantData.states || {});

    states.sort();

    states.forEach((state) => {
      const option = document.createElement("option");

      option.value = state;

      option.textContent = state;

      if (state === selectedState) {
        option.selected = true;
      }

      stateDropdown.appendChild(option);
    });

    if (selectedState) {
      stateDropdown.value = selectedState;
    }
  }

  // UPDATE PRICE
  async function updateLocationPrice(variantId) {
    const variantData = window.variantLocationPrices?.[variantId];

    // NO JSON FOUND
    if (!variantData || typeof variantData !== "object") {
      if (priceEl) {
        priceEl.textContent = defaultPrice;
      }

      if (locationEl) {
        locationEl.textContent = "Ex-Showroom Price*";
      }

      removeLoadingState();

      return;
    }

    // SHOW LOADING STATE
    wrapper.classList.add("loading");

    if (priceText) {
      priceText.classList.add("loading");
    }

    if (mobilePriceWrapper) {
      mobilePriceWrapper.classList.add("loading");
    }

    if (priceEl) {
      priceEl.textContent = "Loading...";
    }

    if (mobilePriceEl) {
      mobilePriceEl.textContent = "Loading...";
    }

    if (locationEl) {
      locationEl.textContent = "Ex-Showroom Price*";
    }

    const availableStates =
      Object.keys(variantData.states || {});

    // DETERMINE TARGET STATE
    let selectedState = activeState;

    // GET LOCATION
    const location = await getUserLocation();

    if (!selectedState && location && location.state) {
      selectedState = location.state;
    }

    if (!selectedState) {
      selectedState = variantData.default?.location || "Delhi";
    }

    if (!availableStates.includes(selectedState)) {
      selectedState = availableStates.includes("Delhi")
        ? "Delhi"
        : availableStates[0] || "";
    }

    activeState = selectedState;

    // RESOLVE PRICE FOR SELECTED STATE
    let finalPrice = "";
    const stateData = selectedState ? variantData.states?.[selectedState] : null;

    if (stateData) {
      if (
        location &&
        location.state === selectedState &&
        location.city &&
        stateData[location.city]?.price
      ) {
        finalPrice = stateData[location.city].price;
      } else if (stateData.price) {
        finalPrice = stateData.price;
      }
    }

    if (!finalPrice) {
      finalPrice = variantData.default?.price || defaultPrice;
    }

    populateStatesDropdown(
      variantData,
      selectedState
    );

    // UPDATE UI
    if (priceEl) {
      priceEl.textContent = finalPrice;
    }

    if (mobilePriceEl) {
      mobilePriceEl.textContent = finalPrice;
    }

    if (locationEl) {
      locationEl.textContent = "Ex-Showroom Price*";
    }

    // REMOVE LOADING
    removeLoadingState();
  }

  // INITIAL LOAD
  setTimeout(() => {
    if (currentVariantId) {
      updateLocationPrice(currentVariantId);
    } else {

      // NO VARIANT FOUND
      if (priceEl) {
        priceEl.textContent = defaultPrice;
      }

      if (locationEl) {
        locationEl.textContent = "Ex-Showroom Price*";
      }

      removeLoadingState();
    }
  }, 300);

  // STATE DROPDOWN CHANGE
  if (!wrapper.dataset.priceInit) {
    wrapper.dataset.priceInit = "true";

    wrapper.addEventListener("change", (e) => {
      if (!e.target.matches(".state-selector")) return;

      const stateDropdown = e.target;

      const variantData =
        window.variantLocationPrices?.[currentVariantId];

      if (!variantData) return;

      const selectedState = stateDropdown.value;
      if (!selectedState) return;

      activeState = selectedState;

      const stateData =
        variantData.states?.[selectedState];

      let price = "";
      if (stateData) {
        if (
          cachedLocation &&
          cachedLocation.state === selectedState &&
          cachedLocation.city &&
          stateData[cachedLocation.city]?.price
        ) {
          price = stateData[cachedLocation.city].price;
        } else if (stateData.price) {
          price = stateData.price;
        }
      }

      if (!price) {
        price = variantData.default?.price || defaultPrice;
      }

      if (priceEl) {
        priceEl.textContent = price;
      }

      if (mobilePriceEl) {
        mobilePriceEl.textContent = price;
      }

      if (locationEl) {
        locationEl.textContent = "Ex-Showroom Price*";
      }
    });
  }

}
